export default {
  selector: {
    defaultFilter: 'Default filter',
    fields: {
      mixFilters: 'Mix filters (AND)',
    },
    buttons: {
      list: 'Manage filters',
    },
  },
};
